
















































































































































import { Component, Vue, PropSync, Watch, Emit, Inject } from 'vue-property-decorator';
import { Getter, Mutation, Action } from 'vuex-class';
// import { CartItem } from '@/store/states';
import TicketCategory, { CartItem } from '@/api/tickets';
import PaypalCheckout, { ApproveActions } from '@/components/PayPalCheckout.vue';
import AnimatedNumber from '@/components/AnimatedNumber.vue';
import { EventInfo } from '@/api/product';
import { Config } from '@/api/config';
import CheckoutStripe from '@/components/stripe/StripeCheckout.vue';
import {
  BtnLayout, ShippingPreference, PreferedPayment, UserAction,
  BtnLabel, ClickData, ClickActions, ApproveData, OrderDetails, OrderError,
} from '@/api/paypal';
import { itemToGtag } from '../api/gtag';
import { CalFeatureFlags } from '../api/utils';

interface MerchantInfo {
  merchant_id: string;
  email_address: string;
}

@Component({
  components: {
    PaypalCheckout,
    AnimatedNumber,
    CheckoutStripe,
  },
  filters: {
    capitalize: (value: string) => {
      if (!value) { return ''; }
      return value[0].toUpperCase() + value.slice(1);
    },
    money: (value: string | number) => {
      const val = Number(value);
      return '$' + val.toFixed(2);
    },
  },
})
export default class Cart extends Vue {
  @PropSync('show', {type: Boolean}) public sync!: boolean;
  @Getter('cart/items') public readonly items!: CartItem[];
  @Getter('tickets/categoryByName') public getPrices!: (name: string) => null | TicketCategory;
  @Mutation('cart/cleanCart') public cleanCart!: () => void;
  @Mutation('cart/removeFromCart') public removeFromCart!: (id: string) => void;
  @Mutation('cart/emptyCart') public emptyCart!: () => void;
  @Mutation('logError') public logErr!: (err: any) => void;
  @Getter('config') public readonly config!: Config;
  @Action('loadConfig') public loadConfig!: () => Promise<void>;
  @Inject() public readonly flags!: CalFeatureFlags;

  public headers = [
    { text: 'Type', align: 'left', value: 'item.name', sortable: false},
    { text: 'Quantity', align: 'left', value: 'quantity', sortable: false},
    { text: 'Price Per Ticket', align: 'left', sortable: false, value: 'price'},
    { text: 'Sub Total', align: 'left', sortable: false, value: 'subtotal'},
    { text: 'Remove', value: 'remove', sortable: false },
  ];

  public valid = true;
  public errormsg = '';
  public terms = false;
  public emaildialog = false;
  public diag = false;
  public btnrender = 0;
  public prom: null | ((value?: boolean) => void) = null;
  public paypalDecline = false;
  public declineText = '';

  public readonly appcontext = {
    shipping_preference: ShippingPreference.NO_SHIPPING,
    user_action: UserAction.PAY_NOW,
    payment_method: {
      payee_preferred: PreferedPayment.IMMEDIATE,
    },
  };


  public get payee(): MerchantInfo {
    return process.env.VUE_APP_PAYPAL_ENV === 'LIVE'
      ? this.live
      : this.sandbox;
  }

  public readonly style = {
    label: BtnLabel.BUYNOW,
    layout: this.flags.verticalPaypal ? BtnLayout.VERTICAL : BtnLayout.HORIZONTAL,
    tagline: false,
  };

  private readonly sandbox: MerchantInfo = {
    merchant_id: process.env.VUE_APP_SANDBOX_ID || '',
    email_address: process.env.VUE_APP_SANDBOX_EMAIL || '',
  };

  private readonly live: MerchantInfo = {
    merchant_id: process.env.VUE_APP_MERCHANT_ID || '',
    email_address: process.env.VUE_APP_MERCHANT_EMAIL || '',
  };

  public onDeclined(err: object, actions: ApproveActions): Promise<object> {
    return actions.restart();
  }

  public checkinit(data: object, actions: object) {
    // console.log(data, actions);
  }

  public mounted() {
    this.loadConfig();
  }

  @Emit('checkout-error')
  public errorHandler(err: OrderError) {
    if (err.name === 'UNPROCESSABLE_ENTITY') {
      if (err.details[0].issue === 'INSTRUMENT_DECLINED') {
        this.errormsg = 'Payment was declined, please try again with a different payment source.';
      } else {
        this.errormsg = 'PayPal was unable to process that payment, please try again or call PayPal for assistance';
      }
    } else {
      this.errormsg = 'Something Went Wrong, please try again.';
    }

    this.logErr(err);
  }

  public close() {
    this.sync = false;
    this.btnrender += 1;
    this.errormsg = '';
  }

  public async clickcheck(data: ClickData, actions: ClickActions) {
    if (this.items.length > 0) {
      this.$gtag.event('begin_checkout', {
        items: this.items.map((i, idx) => ({list_position: idx,  ...itemToGtag(i.item)})),
        coupon: '',
      });

      this.$gtag.event('set_checkout_option', {
        checkout_step: 1,
        checkout_option: 'funding_source',
        value: data.fundingSource === 'card' ? 1 : 0,
      });
      return actions.resolve();
    } else {
      this.errormsg = 'Must put stuff in your cart first';
      return actions.reject();
    }
  }

  public get grouped(): Map<string, number> {
    const ret = new Map<string, number>();
    for (const i of this.items) {
      let cur = ret.get(i.event.startTime);
      if (!cur) {
        cur = 0;
      }
      ret.set(i.event.startTime, cur + Number(i.item.quantity));
    }
    return ret;
  }

  public get subtotal(): number {
    return this.items.reduce((total, curr) => {
      return total + Number(curr.item.unit_amount.value) * Number(curr.item.quantity);
    }, 0);
  }

  public customSort(items: CartItem[], col: string, isDesc: boolean): CartItem[] {
    const factor = isDesc ? -1 : 1;
    return items.sort((a: CartItem, b: CartItem) => {
      if (a.item.sku < b.item.sku) {
        return 1 * factor;
      } else if (a.item.sku > b.item.sku) {
        return -1 * factor;
      } else {
        return 0;
      }
    });
  }

  @Watch('show')
  public onShowChange(value: boolean, oldval: boolean) {
    if (oldval && !value) { this.cleanCart(); }
  }

  @Emit('paypal-approved')
  public approved(data: ApproveData) {
    this.$gtag.event('checkout_progress', {
      items: this.items.map((i, idx) => ({list_position: idx,  ...itemToGtag(i.item)})),
      coupon: '',
      checkout_step: 2,
    });
    this.sync = false;
  }

  @Emit('redeemed-success')
  public redeemed() {
    this.emptyCart();
  }

  @Emit('checkout-success')
  public succeeded(data: OrderDetails) {
    this.emptyCart();
  }
}
